export default class RoomData {
  name = ''
  area = 0.0 as number
  floor = false
  plaster = false
  board = false
  cdp400 = false
  slab16 = false

  replacer = (key: any, value: any) => { // eslint-disable-line
    if (key !== 'attrDesc') return value
  }

  static attrDesc = {
    floor: {
      name: 'Padlófűtés',
      unit: 'm2'
    },
    plaster: {
      name: 'Vakolatos<br>mennyezeti',
      unit: 'm2'
    },
    board: {
      name: 'Gipszkartonos<br>mennyezeti',
      unit: 'm2'
    },
    cdp400: {
      name: 'CDP-400<br/>mennyezeti',
      unit: 'm2'
    },
    slab16: {
      name: 'SLAB-16<br>mennyezeti',
      unit: 'm2'
    }
  }
}
